import { render, staticRenderFns } from "./deviceManage.vue?vue&type=template&id=52a8483f&"
import script from "./deviceManage.vue?vue&type=script&lang=js&"
export * from "./deviceManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports